export default ['us', 'ca'];
